export const Questions = [
   {
      prompt: "Which of this is not a programming language?",
      optionA: "Python",
      optionB: "JavaScript",
      optionC: "MC-03",
      optionD: "Java",
      answer: "optionC",
   },
   {
      prompt: "Which of this is not a javascript framework?",
      optionA: "React",
      optionB: "Angular",
      optionC: "Vue",
      optionD: "Java",
      answer: "optionD",
   },
   {
      prompt: "What does HTML stand for?",
      optionA: "Hyper Trainer Marking Language",
      optionB: "HyperText Markup Language",
      optionC: "HyperText Markdown Language",
      optionD: "HighText Markup Language",
      answer: "optionB",
   },
   {
      prompt: "Which company developed the React library?",
      optionA: "Google",
      optionB: "Microsoft",
      optionC: "Facebook",
      optionD: "Amazon",
      answer: "optionC",
   },
   {
      prompt: "Which of the following is not a JavaScript framework?",
      optionA: "React",
      optionB: "Angular",
      optionC: "Vue",
      optionD: "Django",
      answer: "optionD",
   },
   {
      prompt: "Which command is used to initialize a new Node.js project?",
      optionA: "node init",
      optionB: "npm start",
      optionC: "npm init",
      optionD: "node install",
      answer: "optionC",
   },
   {
      prompt: "Which of these is not a valid data type in JavaScript?",
      optionA: "String",
      optionB: "Boolean",
      optionC: "Float",
      optionD: "Undefined",
      answer: "optionC",
   },
   {
      prompt: "Which HTML tag is used to link JavaScript?",
      optionA: "<link>",
      optionB: "<script>",
      optionC: "<style>",
      optionD: "<meta>",
      answer: "optionB",
   },
];
